module.exports = __webpack_public_path__ + "media/images/client_logos/logo_puig_200-9ccd5159d5e5efbfa9a0c06799b4b769.png";